import Forest from "./forest.png";
import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="overflow-hidden text-emerald-50">
      <div
        className="h-24 w-full bg-white bg-bottom bg-repeat-x"
        style={{ backgroundImage: `url(${Forest})` }}
      />

      <div className="bg-[#102010]">
        <div className="mx-auto grid w-full max-w-7xl gap-8 px-4 pb-8 pt-6 sm:px-6 lg:grid-cols-[1.2fr_1fr_1fr] lg:gap-10 lg:px-8">
          <section>
            <p className="text-xs font-semibold uppercase tracking-[0.24em] text-amber-200">
              Camping des Iles
            </p>
            <h2 className="mt-3 font-['Chewy'] text-3xl text-[#fff6dc]">
              Vivez l&apos;esprit camping
            </h2>
            <p className="mt-3 max-w-md text-sm leading-relaxed text-emerald-100/85">
              Nature, lac, detente et soirees feu de camp dans un decor
              chaleureux.
            </p>
          </section>

          <section>
            <h3 className="text-sm font-semibold uppercase tracking-[0.14em] text-amber-200">
              Navigation
            </h3>
            <nav className="mt-3 grid gap-2 text-sm">
              <Link className="text-emerald-100 no-underline hover:text-white" to="/">
                Accueil
              </Link>
              <Link
                className="text-emerald-100 no-underline hover:text-white"
                to="/informations"
              >
                Informations
              </Link>
              <Link className="text-emerald-100 no-underline hover:text-white" to="/plan">
                Carte
              </Link>
              <Link className="text-emerald-100 no-underline hover:text-white" to="/tarifs">
                Tarifs
              </Link>
              <Link
                className="text-emerald-100 no-underline hover:text-white"
                to="/ou-sommes-nous"
              >
                Nous trouver
              </Link>
            </nav>
          </section>

          <section>
            <h3 className="text-sm font-semibold uppercase tracking-[0.14em] text-amber-200">
              Legal
            </h3>
            <p className="mt-3 text-sm text-emerald-100/85">
              Numero d&apos;enregistrement:
            </p>
            <a
              className="mt-1 inline-block text-base font-semibold text-[#fff6dc] no-underline hover:text-white"
              href="https://www.quebec.ca/tourisme-et-loisirs/hebergement-touristique-courte-duree"
            >
              202764
            </a>
          </section>
        </div>
      </div>
    </footer>
  );
}
